import { NgClass } from '@angular/common';
import * as i0 from '@angular/core';
import { input, model, Component, ViewChild } from '@angular/core';
import * as i1 from '@angular/forms';
import { FormsModule, ControlContainer, NgForm } from '@angular/forms';
import intlTelInput from 'intl-tel-input';

/*
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
const _c0 = ["intlTelInput"];
function IntlTelInputComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 1);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r1.labelCssClass());
    i0.ɵɵattribute("for", ctx_r1.name());
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.label());
  }
}
let IntlTelInputComponent = /*#__PURE__*/(() => {
  class IntlTelInputComponent {
    cssClass = input();
    label = input();
    labelCssClass = input();
    name = input('intl-tel-input-name');
    options = input({});
    required = input(false);
    E164PhoneNumber = model();
    _inputElement;
    _phoneNumber;
    _intlTelInput;
    ngAfterViewInit() {
      const intlTelInputInstance = intlTelInput;
      this._intlTelInput = intlTelInputInstance(this._inputElement.nativeElement, this.options());
    }
    get intlTelInput() {
      return this._intlTelInput;
    }
    get phoneNumber() {
      return this._phoneNumber;
    }
    set phoneNumber(value) {
      if (!!value) {
        this._intlTelInput.setNumber(value);
      }
      this._phoneNumber = value;
      this.i18nizePhoneNumber();
    }
    i18nizePhoneNumber() {
      this.E164PhoneNumber.set(null);
      if (this._intlTelInput.isValidNumber()) {
        this.E164PhoneNumber.set(this._intlTelInput.getNumber());
      }
    }
    static ɵfac = function IntlTelInputComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || IntlTelInputComponent)();
    };
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: IntlTelInputComponent,
      selectors: [["intl-tel-input"]],
      viewQuery: function IntlTelInputComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._inputElement = _t.first);
        }
      },
      inputs: {
        cssClass: [1, "cssClass"],
        label: [1, "label"],
        labelCssClass: [1, "labelCssClass"],
        name: [1, "name"],
        options: [1, "options"],
        required: [1, "required"],
        E164PhoneNumber: [1, "E164PhoneNumber"]
      },
      outputs: {
        E164PhoneNumber: "E164PhoneNumberChange"
      },
      features: [i0.ɵɵProvidersFeature([], [{
        provide: ControlContainer,
        useExisting: NgForm
      }])],
      decls: 3,
      vars: 8,
      consts: [["intlTelInput", ""], [3, "ngClass"], ["type", "text", 3, "ngModelChange", "countrychange", "ngClass", "name", "required", "ngModel"]],
      template: function IntlTelInputComponent_Template(rf, ctx) {
        if (rf & 1) {
          const _r1 = i0.ɵɵgetCurrentView();
          i0.ɵɵtemplate(0, IntlTelInputComponent_Conditional_0_Template, 2, 3, "label", 1);
          i0.ɵɵelementStart(1, "input", 2, 0);
          i0.ɵɵtwoWayListener("ngModelChange", function IntlTelInputComponent_Template_input_ngModelChange_1_listener($event) {
            i0.ɵɵrestoreView(_r1);
            i0.ɵɵtwoWayBindingSet(ctx.phoneNumber, $event) || (ctx.phoneNumber = $event);
            return i0.ɵɵresetView($event);
          });
          i0.ɵɵlistener("countrychange", function IntlTelInputComponent_Template_input_countrychange_1_listener() {
            i0.ɵɵrestoreView(_r1);
            return i0.ɵɵresetView(ctx.i18nizePhoneNumber());
          });
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵconditional(ctx.label() && ctx.name() ? 0 : -1);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngClass", ctx.cssClass())("name", ctx.name())("required", ctx.required());
          i0.ɵɵtwoWayProperty("ngModel", ctx.phoneNumber);
          i0.ɵɵattribute("id", ctx.name())("name", ctx.name())("aria-required", ctx.required() || null);
        }
      },
      dependencies: [NgClass, FormsModule, i1.DefaultValueAccessor, i1.NgControlStatus, i1.RequiredValidator, i1.NgModel],
      encapsulation: 2
    });
  }
  return IntlTelInputComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of intl-tel-input-ng
 */

/**
 * Generated bundle index. Do not edit.
 */

export { IntlTelInputComponent };
